<div class="not-found text-center">
    <img src="img/not-found.gif" class="mb-25" alt="not-found">
    <h4 class="mb-15">Oops!! The page you are looking for doesn't exist!</h4>
    <p class="ms-auto me-auto">The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
    <a mat-raised-button class="tagus mt-8" routerLink="/">Back to Dashboard</a>
</div>